require("./vuetify");
require("./font-awesome");
require("./vue-axios");
require("./vuelidate");
require("./infinite-loading");
require("./moment");
require("./lingallery");
require("./v-lazy-image");
require("./vue-gtag")
